export class DetailCodConfigurationRetail {
  ccoId = 0;
  ccoName = "";
  ccoDescription = "";
  ccoProductType = "";
  ccoMinPrice = 0;
  ccoMaxPrice = 0;
  ccoMinCodValue = 0;
  ccoCodType = "";
  ccoIsInsurance = false;
  ccoCityCode = "";
  ccoCityName = "";
  ccoPercentageCod = 0;
  ccoOriginCommissionPercentage = 0;
  ccoDestinationCommissionPercentage = 0;
  ccoIsDfod = false;
  ccoOriginMinCommission = 0;
  ccoDestinationMinCommission = 0;
  ccoStatus = "inactive";
  ccoCreatedAt = "";
  ccoCreatedBy = "";
  ccoUpdatedAt = "";
  ccoUpdatedBy = "";
  ccoType = "";
  countries: CodInternationalCountry[] = [];

  constructor(fields?: Partial<DetailCodConfigurationRetail>) {
    Object.assign(this, fields);
  }
}

export class CodInternationalCountry {
  uid = 0;
  countryId = 0;
  countryName = "";
  countryCode = "";
  currencyCode = "";
  currencySymbol = "";

  minPrice = "";
  maxPrice = "";
  minCodFee = "";
  posDeliveryCommissionPercentage = "";

  minPriceTouched = false;
  maxPriceTouched = false;
  minCodFeeTouched = false;
  posDeliveryCommissionPercentageTouched = false;
  countryTouched = false;

  constructor(fields?: Partial<CodInternationalCountry>) {
    Object.assign(this, fields);
  }
}

export class EditInternationalForm {
  configId = 0;
  configName = "";
  configDescription = "";
  products = [] as string[];
  countries = [] as CodInternationalCountry[];
  status = false;

  constructor(fields?: Partial<EditInternationalForm>) {
    Object.assign(this, fields);
  }
}
